function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_1121916_cc@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/pound",
  transform: "translate(-3.000000, -1.000000)",
  fill: "#80A1FE",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_1121916_cc",
  transform: "translate(3.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,13.6111111 C10,14.0716667 9.62722222,14.4444444 9.16666667,14.4444444 L1.11111111,14.4444444 C0.736666667,14.4444444 0.407777778,14.1944444 0.308333333,13.8333333 C0.208333333,13.4727778 0.361111111,13.0888889 0.682222222,12.8955556 C1.28944444,12.5327778 1.66666667,11.8661111 1.66666667,11.1577778 L1.66666667,8.33333333 L0.833333333,8.33333333 C0.372777778,8.33333333 0,7.96055556 0,7.5 C0,7.03944444 0.372777778,6.66666667 0.833333333,6.66666667 L1.66666667,6.66666667 L1.66666667,3.73055556 C1.66666667,1.82222222 3.09833333,0.191111111 4.92555556,0.0166666667 C7.07166667,-0.186111111 8.88888889,1.49666667 8.88888889,3.61111111 C8.88888889,4.07166667 8.51611111,4.44444444 8.05555556,4.44444444 C7.595,4.44444444 7.22222222,4.07166667 7.22222222,3.61111111 C7.22222222,2.50277778 6.27666667,1.56277778 5.08388889,1.67611111 C4.10222222,1.76944444 3.33333333,2.67222222 3.33333333,3.73055556 L3.33333333,6.66666667 L5.27777778,6.66666667 C5.73833333,6.66666667 6.11111111,7.03944444 6.11111111,7.5 C6.11111111,7.96055556 5.73833333,8.33333333 5.27777778,8.33333333 L3.33333333,8.33333333 L3.33333333,11.1577778 C3.33333333,11.7261111 3.2,12.28 2.95611111,12.7777778 L9.16666667,12.7777778 C9.62722222,12.7777778 10,13.1505556 10,13.6111111 Z",
  id: "Shape"
}))));

var SvgGbp = function SvgGbp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "15px",
    viewBox: "0 0 10 15",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGbp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gbp.cd3e8b05.svg";
export { ForwardRef as ReactComponent };